var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',_vm._l((_vm.organizations),function(organizationItem,organizationIndex){return _c('JobsTreeOrganizationItem',{key:`organization_${organizationIndex}`,attrs:{"organization":organizationItem,"jobs":_vm.jobs,"onArchiveJob":_vm.onArchiveJob,"unfold":_vm.unfold}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }